module.exports = __webpack_public_path__ + "static/media/ee.8d2ee6f8.svg";